/**
 * @fileoverview GET handler for the "/deliverability/postmaster/:app_group_id/ips" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { deliverabilityPostmasterAppGroupIdIps } from "./constants";
import type { DeliverabilityPostmasterAppGroupIdIpsResult } from "./types";

export const getDeliverabilityPostmasterAppGroupIdIps = reactQueryFetcherAdapter(
  deliverabilityPostmasterAppGroupIdIps,
  (
    signal: AbortSignal,
    appGroupId: string,
    // eslint-disable-next-line camelcase
    start_date: string,
    // eslint-disable-next-line camelcase
    end_date: string
  ): Promise<DeliverabilityPostmasterAppGroupIdIpsResult> => {
    return fetch(`/deliverability/postmaster/${appGroupId}/ips`, "GET", { start_date, end_date }, { signal });
  }
);
